import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UploadBannerUseCaseInterface } from 'domain/usecases';

export class RemoteUploadBanner implements UploadBannerUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<UploadBannerUseCaseInterface.Result>,
  ) {}

  async execute(
    params: UploadBannerUseCaseInterface.Params,
  ): Promise<UploadBannerUseCaseInterface.Result> {
    const { banner } = params;
    const httpResponse = await this.httpClient.request({
      method: 'patch',
      url: this.url + '/' + params.id,
      body: { banner },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
